import React, { useEffect, useState } from 'react';
import {ToastComponent, AlertComponent, Spinner} from 'amis';
/**
 * BrowserRouter: history 路由模式
 * HashRouter: hash 路由模式
 */
import {Route, Switch, Redirect, HashRouter as Router} from 'react-router-dom';
import {observer} from 'mobx-react';
import {IMainStore} from '../store/index';
// import Preview from './Preview';
// import Editor from './Editor';
import '../renderer/MyRenderer';
// import '../renderer/GridPlugin1';
import '../renderer/GridPlugin/index';
// import '../renderer/FlowEnginePlugin/index';
import '../renderer/AIGridPlugin';
import '../renderer/DashboardPlugin';
import '../renderer/PdfViewerPlugin';
import '../renderer/AIChatbotPlugin';
import '../renderer/AISvgPlugin';
import '../renderer/AIPlcCoderPlugin';
import '../renderer/AIHmiPlugin';
import '../renderer/AIElectricalSelectionPlugin';
const Preview = React.lazy(() => import('./Preview'));
const Editor = React.lazy(() => import('./Editor'));

export default observer(function ({store}: {store: IMainStore}) {
  if (store.AGIMX_APP_MODE === 'editor') {
    return (
      <Router>
        <div className="routes-wrapper">
          <ToastComponent key="toast" position={'top-center'} />
          <AlertComponent key="alert" />
          <React.Suspense
            fallback={<Spinner overlay className="m-t-lg" size="lg" />}
          >
            <Switch>
              <Redirect to={`/aside-nav`} from={`/`} exact />
              {/* <Route path="/edit/:id" component={Editor} /> */}
              <Route path="/edit/:route" component={Editor} />
              <Route component={Preview} />
            </Switch>
          </React.Suspense>
        </div>
      </Router>
    );
  } else {
    return (
      <Router>
        <div className="routes-wrapper">
          <ToastComponent key="toast" position={'top-center'} />
          <AlertComponent key="alert" />
          <React.Suspense
            fallback={<Spinner overlay className="m-t-lg" size="lg" />}
          >
            <Switch>
              {/* <Redirect to={`/login`} from={`/`} exact /> */}
              <Route component={Preview} />
            </Switch>
          </React.Suspense>
        </div>
      </Router>
    );
  }
});
